import { useTranslation } from 'react-i18next';
import {
  BackToSignInLink,
  ForgotPasswordContent,
  ForgotPasswordPromoPane,
  PasswordResetLayout,
  StepIndicator,
} from '@features/PasswordReset';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  return (
    <PasswordResetLayout
      promo={<ForgotPasswordPromoPane activeIndex={0} />}
      topRight={<BackToSignInLink />}
      stepIndicator={
        <StepIndicator
          steps={[
            { label: t('auth.forgot.stepTags.a'), state: 'active' },
            { label: t('auth.forgot.stepTags.b'), state: 'upcoming' },
            { label: t('auth.forgot.stepTags.c'), state: 'upcoming' },
          ]}
        />
      }
    >
      <ForgotPasswordContent />
    </PasswordResetLayout>
  );
}
